import { useCallback } from "react";
import { Redirect, RouteComponentProps, useHistory } from "react-router-dom";
import { Layout } from "../../../shared/components/Layout";
import { PATH_PLATFORM_BALANCE } from "../../PlatformBalance/paths";
import { PATH_TAXES } from "../../Taxes/paths";
import { FormTransfer } from "../components/FormTransfer";
import { FormType } from "../components/FormType";
import { useSearchParams } from "../useSearchParams";

export const RouteIndex: React.FC<RouteComponentProps> = ({
  location: { pathname, search }
}) => {
  const history = useHistory();

  const { balance, type } = useSearchParams();

  const onBack = useCallback(() => {
    switch (balance) {
      case "wallet":
        history.push("/member/wallet");
        break;
      case "taxWithholdings":
        history.push(PATH_TAXES);
        break;
      case "platform":
        history.push(PATH_PLATFORM_BALANCE);
        break;
    }
  }, [balance, history]);

  if (!balance) {
    return <Redirect to="/member/dashboard" />;
  }

  return (
    <Layout title="Transfer balance" wide onClose={onBack}>
      {type ? (
        <FormTransfer
          balance={balance}
          type={type}
          onCancel={onBack}
          onSuccess={onBack}
        />
      ) : (
        <FormType
          balance={balance}
          onDeposit={() => {
            history.push(pathname + search + "&type=deposit");
          }}
          onWithdrawal={() => {
            history.push(pathname + search + "&type=withdrawal");
          }}
        />
      )}
    </Layout>
  );
};
